import HtmlElement from './HtmlElement';
import HtmlElementDefinition from './HtmlElementDefinition';
import HtmlElementMetaData from './HtmlElementMetaData';

export default {
  HtmlElement: HtmlElement,
  HtmlElementDefinition: HtmlElementDefinition,
  HtmlElementType: HtmlElementMetaData.type
};
